import { Component } from '@angular/core';

@Component({
  selector: 'app-help',
  template: `
  <h2>Content Resources</h2>

  <p>
    If you require assistance in deciphering any of the abbreviations or acronyms used in the pages or documents
    located on this site, please review our list of Abbreviations:<br />
    <a [routerLink]="['/abbreviations']">Abbreviations</a>
  </p>

  <h2>Navigational Issues</h2>

  <p>
    If you are having difficulty getting access to the information you need, please visit our Site Map:<br />
    <a [routerLink]="['/sitemap']">Site Map</a>
  </p>

  <h2>Technical Issues</h2>

  <p>
    If you are having technical issues with this Web site, please contact our Webmaster for further assistance:<br />
    <a href="mailto:kmyers@dandp.com?subject=Technical%20Issues%20with%20the%20USDA%20BARC%20IR%2FAR%20Website">Contact Webmaster</a>
  </p>
  `
})
export class HelpComponent { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/help.ts